import React from 'react';

import Tabs from '../../../../../components/Tabs';
import AccountUserDetailUserInfo from '../AccountUserDetailUserInfo';
import AccountUserDetailOrderInfo from '../AccountUserDetailOrderInfo';
import AccountUserDetailCouponInfo from '../AccountUserDetailCouponInfo';
import AccountUserDetailPointInfo from '../AccountUserDetailPointInfo';
import AccountUserDetailCartInfo from '../AccountUserDetailCartInfo';
import AccountUserDetailCsInquiryInfo from '../AccountUserDetailCsInquiryInfo';
import AccountUserDetailCsQnaInfo from '../AccountUserDetailCsQnaInfo';
import AccountUserDetailCsReviewInfo from '../AccountUserDetailCsReviewInfo';
import AccountUserDetailTagInfo from '../AccountUserDetailTagInfo';
import AccountUserDetailLikeProductInfo from '../AccountUserDetailLikeProductInfo';
import AccountUserDetailLikeBrandInfo from '../AccountUserDetailLikeBrandInfo';
import { ACCOUNT_USER_DETAIL_TAB_KEY } from '../../../../../constants/service/app/accountUserConstants';
import AccountUserDetailGrade from '../AccountUserDetailGrade';
import AccountUserDetailDeviceList from '../AccountUserDetailDeviceList';
import './AccountUserDetailWrap.scss';

const AccountUserDetailWrap = (props) => {
  const { userId, setTabKey, currentTabKey } = props;

  return (
    <div className="account-user-detail-wrap">
      {/*유저 상세*/}
      <Tabs
        activeKey={currentTabKey}
        onChange={(tabKey) => setTabKey(tabKey)}
        list={[
          {
            title: '유저 정보',
            content: (
              <AccountUserDetailUserInfo
                userId={userId}
                isActive={currentTabKey === ACCOUNT_USER_DETAIL_TAB_KEY.USER_INFO}
              />
            ),
          },
          {
            title: '주문 정보',
            content: (
              <AccountUserDetailOrderInfo
                userId={userId}
                isActive={currentTabKey === ACCOUNT_USER_DETAIL_TAB_KEY.ORDER_INFO}
              />
            ),
          },
          {
            title: '쿠폰 정보',
            content: (
              <AccountUserDetailCouponInfo
                userId={userId}
                isActive={currentTabKey === ACCOUNT_USER_DETAIL_TAB_KEY.COUPON_INFO}
              />
            ),
          },
          {
            title: '포인트 정보',
            content: (
              <AccountUserDetailPointInfo
                userId={userId}
                isActive={currentTabKey === ACCOUNT_USER_DETAIL_TAB_KEY.POINT_INFO}
              />
            ),
          },
          {
            title: '장바구니 정보',
            content: (
              <AccountUserDetailCartInfo
                userId={userId}
                isActive={currentTabKey === ACCOUNT_USER_DETAIL_TAB_KEY.CART_INFO}
              />
            ),
          },
          {
            title: '1:1 문의 내역 정보',
            content: (
              <AccountUserDetailCsInquiryInfo
                userId={userId}
                isActive={currentTabKey === ACCOUNT_USER_DETAIL_TAB_KEY.CS_INQUIRY_INFO}
              />
            ),
          },
          {
            title: '상품 문의 내역 정보',
            content: (
              <AccountUserDetailCsQnaInfo
                userId={userId}
                isActive={currentTabKey === ACCOUNT_USER_DETAIL_TAB_KEY.CS_QNA_INFO}
              />
            ),
          },
          {
            title: '상품 후기 정보',
            content: (
              <AccountUserDetailCsReviewInfo
                userId={userId}
                isActive={currentTabKey === ACCOUNT_USER_DETAIL_TAB_KEY.CS_REVIEW_INFO}
              />
            ),
          },
          {
            title: '팔로우한 태그 정보',
            content: (
              <AccountUserDetailTagInfo
                userId={userId}
                isActive={currentTabKey === ACCOUNT_USER_DETAIL_TAB_KEY.TAG_INFO}
              />
            ),
          },
          {
            title: '좋아요한 상품 정보',
            content: (
              <AccountUserDetailLikeProductInfo
                userId={userId}
                isActive={currentTabKey === ACCOUNT_USER_DETAIL_TAB_KEY.LIKE_PRODUCT_INFO}
              />
            ),
          },
          {
            title: '좋아요한 브랜드 정보',
            content: (
              <AccountUserDetailLikeBrandInfo
                userId={userId}
                isActive={currentTabKey === ACCOUNT_USER_DETAIL_TAB_KEY.LIKE_BRAND_INFO}
              />
            ),
          },
          {
            title: '디바이스 리스트',
            content: (
              <AccountUserDetailDeviceList
                userId={userId}
                isActive={currentTabKey === ACCOUNT_USER_DETAIL_TAB_KEY.DEVICE_LIST}
              />
            ),
          },
          {
            title: '등급 정보',
            content: (
              <AccountUserDetailGrade
                userId={userId}
                isActive={currentTabKey === ACCOUNT_USER_DETAIL_TAB_KEY.GRADE_INFO}
              />
            ),
          },
        ]}
      />
    </div>
  );
};

export default AccountUserDetailWrap;
